export enum NoticeActions {
  NOTICE_FETCH = 'NOTICE_FETCH',
  NOTICE_SET = 'NOTICE_SET',
  SET_NOTICE_LOADING = 'SET_NOTICE_LOADING',
}
